/**
 * Consists constants value used for permission management
 */
export const namespace = "MSTI";

export const personActorType = "principal";

export const regionOperations = {
  NA: "can_access_NA",
  JP: "can_access_JP",
  EU: "can_access_EU",
};

export const businessUnitOperations = {
  MFN_INDIA: "MFN_INDIA",
  STANDARD: "STANDARD",
  SBR1: "SBR1",
  OOC_STANDARD: "OOC_STANDARD",
  OOC_SBR1: "OOC_SBR1",
};

export const UIRecordOperations = {
  canView: "can_view",
  canCreate: "can_create",
};

export const UIRoleOperations = {
  canAccess: "can_access",
};

export const ResourceTypeOperations = {
  canView: "can_view",
  canEdit: "can_edit",
  canReview: "can_review",
};

export const resourceType = {
  UIRoleResourceType: "TTSelfServeRole",
  businessUnitResourceType: "TTSelfServeBusinessUnit",
  ComponentKeyValueResourceType: "TTSelfServeComponentKeyValue",
};

export const resourceName = {
  region: "Region",
  businessUnit: "BusinessUnit",
  admin: "Admin",
  onboardingRequestId: "OnboardingRequest",
  updateTransitTimeRequestId: "UpdateTransitTime",
  updateValidationThresholdId: "UpdateValidationThreshold",
  changeTransitTimeActiveVersionId: "DownloadReports",
  pendingApprovalRequestsId: "PendingApprovalRequests",
  changeTransitTimeConfigurationId: "SwitchTransitTime",
  viewPreviousRequestId: "ViewHistory",
  updateTransitTimeOverridesId: "AddRemoveOverrides",
  managePermissionsId: "ManagePermission",
  superUser: "SuperUser",
};

export const accessControlResourceMapper = {
  admin: {
    name: resourceName.admin,
    type: resourceType.UIRoleResourceType,
    operations: [UIRoleOperations.canAccess],
  },
  businessUnitResource: {
    type: resourceType.businessUnitResourceType,
    operations: [ResourceTypeOperations.canEdit],
  },
  componentKeyValueResource: {
    type: resourceType.ComponentKeyValueResourceType,
    operations: [],
  },
  superUser: {
    name: resourceName.superUser,
    type: resourceType.UIRoleResourceType,
    operations: [UIRoleOperations.canAccess],
  },
};

export enum UserPermissionsStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum UserActionEnum {
  SUBMIT = "SUBMIT",
  CANCEL = "CANCEL",
}

export const RESOURCE_NAME_SEPARATOR = ":";
